import { AddressInfo, customerData } from "./CustomerData"
import { apiURL } from "./URLs"

export const stateOptions = {
  'Alabama': 'AL', 'Alaska': 'AK', 'Arizona': 'AZ', 'Arkansas': 'AR', 'California': 'CA',
  'Colorado': 'CO', 'Connecticut': 'CT', 'Delaware': 'DE', 'Florida': 'FL', 'Georgia': 'GA',
  'Hawaii': 'HI', 'Idaho': 'ID', 'Illinois': 'IL', 'Indiana': 'IN', 'Iowa': 'IA',
  'Kansas': 'KS', 'Kentucky': 'KY', 'Louisiana': 'LA', 'Maine': 'ME', 'Maryland': 'MD',
  'Massachusetts': 'MA', 'Michigan': 'MI', 'Minnesota': 'MN', 'Mississippi': 'MS', 'Missouri': 'MO',
  'Montana': 'MT', 'Nebraska': 'NE', 'Nevada': 'NV', 'New Hampshire': 'NH', 'New Jersey': 'NJ',
  'New Mexico': 'NM', 'New York': 'NY', 'North Carolina': 'NC', 'North Dakota': 'ND', 'Ohio': 'OH',
  'Oklahoma': 'OK', 'Oregon': 'OR', 'Pennsylvania': 'PA', 'Rhode Island': 'RI', 'South Carolina': 'SC',
  'South Dakota': 'SD', 'Tennessee': 'TN', 'Texas': 'TX', 'Utah': 'UT', 'Vermont': 'VT',
  'Virginia': 'VA', 'Washington': 'WA', 'West Virginia': 'WV', 'Wisconsin': 'WI', 'Wyoming': 'WY'
}

export function formatPhoneNumber(phoneNumber) {
  const digits = phoneNumber.replace(/^\+1|\D/g, '')

  if (digits.length === 10)
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
  else
    return phoneNumber
}

export function getPartOfDay() {
  const hour = new Date().getHours()

  if (hour < 12) return 'Good Morning, '
  if (hour < 18) return 'Good Afternoon, '
  return 'Good Evening, '
}

export function shouldShowChartConnect() {
  return customerData.customerLeadData.leadStage.leadStageId === '36361e99-41da-46bc-b559-67078e125228' &&
  !customerData.customerLeadData.leadContact.chartAccessToken && 
  !customerData.customerLeadData.leadContact.taxStatusId ? true : false
}

export function shouldShowTaxStatusToChart(currentStage) {
  return currentStage.customerStageName === 'ID.me Connection Needed' && !customerData.customerLeadData.leadContact.chartAccessToken ? true : false
}

export function shouldShowChartInstantCalculation(currentStage) {
  return currentStage.customerStageName === 'ID.me Connection Needed' && customerData.customerLeadData.leadContact.chartAccessToken && !customerData.customerLeadData.leadContact.chartInstantAccessToken ? true : false
}

export function shouldShowDocuments(currentStage) {
  if (currentStage.customerStageName === 'Banking Information Added' ||
    currentStage.customerStageName === 'SETC Packet Sent' ||
    currentStage.customerStageName === 'SETC Packet Sent - Pre-Paid' ||
    currentStage.customerStageName === 'Documents Available' ||
    currentStage.customerStageName === 'Documents Available - Advance Funding')
    return true
  else
    return false
}

export function showRefundCalculatedWindow(currentStage) {
  return currentStage.customerStageName === 'Refund Calculated' && !customerData.customerInvoiceData.invoicePaid /*&& customerData.customerLeadData.leadContact.contactId === 'f7872e5b-bd69-47d7-ab9b-91e6b24fb5d0'*/ ? true : false
}

export function showPendingCalcWindow(currentStage) {
  return currentStage.customerStageName === 'Pending Calculations' ? true : false
}

export function showCollectionsWindow(currentStage) {
  return currentStage.customerStageName === 'Collections' && customerData.customerInvoiceData.invoiceId
}

export function savedRefund() {
  return (((customerData.customerLeadData.leadAmount * 0.2) + (customerData.customerLeadData.leadAmount * 0.2) * 0.06) - ((customerData.customerLeadData.leadAmount * 0.15) + (customerData.customerLeadData.leadAmount * 0.15) * 0.06)).toFixed(2)
}

export async function refreshAccessToken() {
  const refreshAccessTokenResponse = await fetch(`${apiURL}/api/refreshAccessToken`, {
    credentials: 'include'
  })
  const refreshAccessTokenData = await refreshAccessTokenResponse.json()
  if (refreshAccessTokenData.response.error) {
    localStorage.removeItem('customerAccessToken')
    return ''
  } else {
    localStorage.setItem('customerAccessToken', refreshAccessTokenData.response.accessToken)
    customerData.accessToken = refreshAccessTokenData.response.accessToken

    return refreshAccessTokenData.response.accessToken
  }
}

export function getTrackingURL(trackingCourier, trackingNumber) {
  switch (trackingCourier) {
    case 'FedEx':
      return `https://www.fedex.com/fedextrack/?tracknumbers=${trackingNumber}`
    case 'UPS':
      return `https://www.ups.com/track?tracknum=${trackingNumber}`
    case 'USPS':
      return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${trackingNumber}`
    case 'DHL':
      return `https://www.dhl.com/en/express/tracking.html?AWB=${trackingNumber}&brand=DHL`
    default:
      return ''
  }
}

export const availableJanuaryDates = [
  '2021-01-01', '2021-01-04', '2021-01-05', '2021-01-06', '2021-01-07', '2021-01-08',
  '2021-01-11', '2021-01-12', '2021-01-13', '2021-01-14', '2021-01-15', '2021-01-18',
  '2021-01-19', '2021-01-20', '2021-01-21', '2021-01-22', '2021-01-25', '2021-01-26',
  '2021-01-27', '2021-01-28', '2021-01-29'
]

export const availableAprilDates = [
  '2021-04-01', '2021-04-02', '2021-04-05', '2021-04-06', '2021-04-07', '2021-04-08',
  '2021-04-09', '2021-04-12', '2021-04-13', '2021-04-14', '2021-04-15', '2021-04-16',
  '2021-04-19', '2021-04-20', '2021-04-21', '2021-04-22', '2021-04-23', '2021-04-26',
  '2021-04-27', '2021-04-28', '2021-04-29', '2021-04-30'
]

/**
 * 
 * @param {AddressInfo} newUserAddress 
 * @param {Boolean} customerFound
 * @returns 
 */
export function checkQualifies(newUserAddress, customerFound) {
  return (customerData.customerLeadData.leadAmount < 3000 ||
    customerData.customerLeadData.leadStage.leadStageId === '034d6ab6-f2dc-47b9-a420-63df42b87381' ||
    newUserAddress.state === 'Colorado' || newUserAddress.state === 'Ohio' || newUserAddress.country !== 'US' ||
    customerFound
  ) ? false : true
}

function getTreasuryAddress(city, state, zip) {
  return new AddressInfo({
    street1: 'Department of the Treasury Internal Revenue Service',
    city,
    state,
    zip,
    country: 'US',
  });
}

function getCarrierSpecificAddress(street1, city, state, zip) {
  return new AddressInfo({
    street1,
    city,
    state,
    zip,
    country: 'US',
  });
}

export function getShippoAddress(refundType, state, specificCarrier) {
  if (refundType === 'Advance Funding') {
    return new AddressInfo({
      street1: '101 Creekside Ridge Ct',
      street2: 'Suite 225B',
      city: 'Roseville',
      state: 'CA',
      zip: '95678',
      country: 'US'
    })
  }

  const isUSPS = specificCarrier === 'USPS'

  if (kansasCityAddress.includes(state)) {
    return isUSPS ? getTreasuryAddress('Kansas City', 'MO', '64999-0052') : getCarrierSpecificAddress('333 W. Pershing', 'Kansas City', 'MO', '64108');
  }

  if (austinAddress.includes(state)) {
    return isUSPS ? getTreasuryAddress('Austin', 'TX', '73301-0052') : getCarrierSpecificAddress('3651 S IH35', 'Austin', 'TX', '78741');
  }

  if (ogdenAddress.includes(state)) {
    return isUSPS ? getTreasuryAddress('Ogden', 'UT', '84201-0052') : getCarrierSpecificAddress('1973 Rulon White Blvd', 'Ogden', 'UT', '84201');
  }

  return isUSPS ? getTreasuryAddress('Austin', 'TX', '73301-0215') : getCarrierSpecificAddress('3651 S IH35', 'Austin', 'TX', '78741');
}

const kansasCityAddress = [
  'Connecticut', 'Delaware', 'District of Columbia', 'Illinois', 'Indiana', 'Kentucky', 'Maine', 'Maryland', 'Massachusetts', 'Minnesota', 'Missouri',
  'New Hampshire', 'New Jersey', 'New York', 'North Carolina', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'Tennesse', 'Vermont', 'Virginia',
  'West Virginia', 'Wisconsin'
]

const austinAddress = [
  'Alabama', 'Arkansas', 'Florida', 'Georgia', 'Louisiana', 'Mississippi', 'Oklahoma', 'Texas'
]

const ogdenAddress = [
  'Alaska', 'Arizona', 'California', 'Colorado', 'Hawaii', 'Idaho', 'Iowa', 'Kansas', 'Michigan', 'Montana', 'Nebraska', 'Nevada', 'New Mexico', 'North Dakota',
  'Ohio', 'Oregon', 'South Dakota', 'Utah', 'Washington', 'Wyoming'
]

export function getCustomerTaxInfo() {
  if(customerData.customerLeadData.leadContact.chartInstantAccessToken) {
    return {
      providerId: customerData.customerLeadData.leadContact.chartInstantAccessToken,
      providerName: 'Chart',
      creditAmount: customerData.customerLeadData.leadAmount
    }
  } else if(customerData.customerLeadData.leadContact.chartAccessToken) {
    return {
      providerId: customerData.customerLeadData.leadContact.chartAccessToken,
      providerName: 'Chart',
      creditAmount: customerData.customerLeadData.leadAmount
    }
  } else {
    return {
      providerId: customerData.customerLeadData.leadContact.taxStatusId,
      providerName: 'Tax Status',
      creditAmount: customerData.customerLeadData.leadAmount
    }
  }
}

export function darkenColor(color, percentage) {
  const num = parseInt(color.slice(1), 16)
  const amt = Math.round(2.55 * percentage)
  const R = Math.max((num >> 16) - amt, 0)
  const G = Math.max(((num >> 8) & 0x00ff) - amt, 0)
  const B = Math.max((num & 0x0000ff) - amt, 0)

  const hex = (1 << 24 | (R << 16) | (G << 8) | B).toString(16).slice(1).toUpperCase()

  return `#${hex}`
}

export function getCompanyURL(companyId) {
  switch(companyId) {
    case '11565d9b-2028-4b8e-86ae-0eaa939ddf61':
      return 'https://portal.kbrsetc.com'
    case '1d622c43-baf3-45b6-8225-ec055b0e39f6':
      return 'https://pros.setctaxreturn.com'
    case '2f38a836-cecc-4bdb-9b9a-2eec22b0db6d':
      return 'https://portal.aitsolution.us'
    case '7bbe1706-8e21-4626-85f4-0a7e7b77acf2':
      return 'https://home.ffcrarefund.com'
    default:
      return 'https://myportal.setcpros.com'
  }
}

export function getCompanyGTMID(companyId) {
  switch(companyId) {
    case '1d622c43-baf3-45b6-8225-ec055b0e39f6':
      return process.env.REACT_APP_SETCTAXRETURN_GTM_ID
    case '7bbe1706-8e21-4626-85f4-0a7e7b77acf2':
      return process.env.REACT_APP_ADESSO_GTM_ID
    default:
      return ''
  }
}

export function getDefaultCompanyId(hostname) {
  switch(hostname) {
    case 'portal.kbrsetc.com':
      return '11565d9b-2028-4b8e-86ae-0eaa939ddf61'
    case 'pros.setctaxreturn.com':
      return '1d622c43-baf3-45b6-8225-ec055b0e39f6'
    case 'portal.aitsolution.us':
      return '2f38a836-cecc-4bdb-9b9a-2eec22b0db6d'
    case 'home.ffcrarefund.com':
      return '7bbe1706-8e21-4626-85f4-0a7e7b77acf2'
    default:
      return '6243c824-9e29-46da-94c6-96d03d8cbb84'
  }
}

export function getGTMDataLayerBody(companyId, queryParams, event) {
  switch(companyId) {
    case '1d622c43-baf3-45b6-8225-ec055b0e39f6':
      return {
        dataLayer: {
          event: event,
          gclid: queryParams.gclid ?? ''
        }
      }
    case '7bbe1706-8e21-4626-85f4-0a7e7b77acf2':
      return {
        dataLayer: {
          event: event,
          gclid: queryParams.gclid ?? '',
          utm_source: queryParams.utm_source ?? '',
          utm_medium: queryParams.utm_medium ?? '',
          utm_campaign: queryParams.utm_campaign ?? ''
        }
      }
  }
}